import { z } from 'zod';
export var appSchema = z.enum(['noteclosings', 'paperstac', 'partners'], {
    required_error: 'Initiating app context is required. Reload the app and submit a fresh request.',
    invalid_type_error: 'Initiating app context is invalid. Reload the app and submit a fresh request.',
});
export var activeAppSchema = appSchema.exclude(['noteclosings']);
export var getAppName = function (app) {
    return ({
        noteclosings: 'NoteClosings',
        paperstac: 'Paperstac',
        partners: 'Paperstac Partners',
    })[appSchema.parse(app)];
};
export var DEFAULT_MARKETPLACE_ID = '_paperstac_public';
/** Identity is shared across apps; branding belongs to the initiating request/job. */
export function requireAppContext(value) {
    var result = activeAppSchema.safeParse(value);
    if (!result.success)
        throw new Error('Missing or invalid initiating app context. Submit a fresh request from a supported app.');
    return result.data;
}
export var isLegacyProfileInScope = function (profile, app) {
    return !!profile &&
        profile.app === app &&
        (app === 'paperstac' ? profile.marketplaceId === DEFAULT_MARKETPLACE_ID : profile.marketplaceId == null);
};
